<div class="container d-flex align-items-center justify-content-center min-vh-100 py-5">
    <div class="card p-5 shadow-lg border-0 rounded-4 text-center" style="max-width: 550px; width: 100%;">
        <div class="mb-4">
            <div class="success-checkmark mx-auto">
                <div class="check-icon">
                    <span class="icon-line line-tip"></span>
                    <span class="icon-line line-long"></span>
                    <div class="icon-circle"></div>
                    <div class="icon-fix"></div>
                </div>
            </div>
        </div>
        <h1 class="display-5 fw-bold text-dark mb-3">Detail not found!</h1>
        <div class="alert alert-warning border-0 rounded-3 py-3 mb-4">
            <i class="bi bi-envelope-check-fill me-2"></i>
            Please check URL or contact with institute admin. <br>Invalid document upload URL.
        </div>
    </div>
</div>
